import React from 'react';
import T from 'prop-types';

import styles from './Layout.scss';

const Layout = ({ body, footer }) => {
    return (
        <div className={styles.Layout} data-cy="Layout">
            <div className={styles.Layout__Body} data-cy="Layout-body">{body}</div>
            {footer && <div className={styles.Layout__Footer} data-cy="Layout-footer">{footer}</div>}
        </div>
    );
};

Layout.propTypes = {
    body: T.node,
    footer: T.node
};

export default Layout;
